import './App.css';
// import { BrowserRouter as Router } from 'react-router-dom';

import { Layout } from 'antd';
import { useState } from 'react';
import Sidebar from './jsx/layout/SideBar';
import FooterBar from './jsx/layout/FooterBar';
import AppRoutes from './jsx/layout/nav/AppRoutes';
import { NotifyInitializer, NotifyProvider } from './jsx/components/Customs/NotifyProvider';
import { useNavigate } from 'react-router-dom';
import { setNavigator } from './jsx/components/Customs/navigation';

const { Header, Footer, Sider, Content } = Layout;

function App() {
  const [collapsed, setCollapsed] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  const navigate = useNavigate();
  setNavigator(navigate);


  return (

    <NotifyProvider>
      <NotifyInitializer />

        {/* Content */}
        <Content style={{
          
        }}>

          <style> {`::-webkit-scrollbar { display: none;}`}</style>
          <AppRoutes />
        </Content>


    </NotifyProvider>
  );
}

export default App;